import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=13e22763&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=13e22763&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e22763",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e22763')) {
      api.createRecord('13e22763', component.options)
    } else {
      api.reload('13e22763', component.options)
    }
    module.hot.accept("./CommonForm.vue?vue&type=template&id=13e22763&scoped=true", function () {
      api.rerender('13e22763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/CommonForm.vue"
export default component.exports